import helper from '../helpers/ApiUrlHelper.js';
export default {
  getDetails(slug, jobofferId, isInternal) {
    return fetch(
      `${helper.apiUrl()}/job/details?slug=${slug}&jobofferId=${jobofferId}&isInternal=${isInternal}`
    );
  },

  getJoboffer(jobofferId, token) {
    return fetch(
      `${helper.apiUrl()}/job?jobofferId=${jobofferId}&token=${token}`
    );
  },

  getStatus(jobofferId, identifier, token) {
    const query = new URLSearchParams({ jobofferId, token, identifier });
    return fetch(`${process.env.VUE_APP_API_URL}/job/status?${query}`);
  },

  getJoboffers(slug) {
    return fetch(`${helper.apiUrl()}/company/listjobs/${slug}`);
  },

  getInternalJoboffers(slug, token) {
    return fetch(
      `${helper.apiUrl()}/company/listinternaljobs?slug=${slug}&internalToken=${token}`
    );
  }
};
